<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useRoleStore} from "@/stores/Setting/Role";
import {useSecurityStore} from "@/stores/Security";
import {onMounted} from "vue";
import axios from "axios";

export default {
    setup() {
        const {loading, filter} = useSharedData();
        const {transformFilterValues} = useSharedMethod();
        const {$i18n, $router} = useTools();
        
        const roleStore = useRoleStore();
        const securityStore = useSecurityStore();
        
        const actions = [
            {
                title: "Gestion des Privillèges",
                icon: 'mdi-security',
                color: 'purple',
                access: () => securityStore.authorities['UPDATE_PRIVILEGE_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'roles.privileges.edit', params: {roleId: item.id}})
                },
            },
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_PRIVILEGE_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'roles.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['UPDATE_PRIVILEGE_PARAM'],
                disabled: () => false,
                func: (item) => {
                    $router.push({name: 'roles.delete', params: {id: item.id}})
                },
            },
        ];
        
        const headers = [
            {
                text: "....",
                align: "left",
                sortable: false,
                value: "action",
                width: "0%"
            },
            {
                text: $i18n.t("common.label"),
                value: "name",
                align: "left",
                sortable: true,
            },
            {
                text: $i18n.t("common.comment"),
                value: "description",
                align: "left",
                sortable: true,
            },
        ];
        
        function findAll() {
            loading.value = true;
            axios.get('/roles', {params: transformFilterValues(filter.value)}).then((response) => {
                roleStore.setRoles(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function view(item) {
            $router.push({name: "roles.privileges.view", params: {roleId: item.id}});
        }
        
        onMounted(() => findAll());
        
        
        return {
            roleStore,
            securityStore,
            actions,
            headers,
            loading,
            filter,
            view,
            findAll,
        };
    }
};
</script>

<template>
    <div>
        <w-app
            :title="$t('module.roles')"
            :total="roleStore.roles.length"
        >
            <template #rightToolbar>
                <w-btn-reload @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['UPDATE_PRIVILEGE_PARAM']"
                    @press="$router.push({ name: 'roles.add' })"
                />
            </template>
            
            <template #content>
                <w-data-table
                    :headers="headers"
                    :actions="actions"
                    :items="roleStore.roles"
                    :loading="loading"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.name`]="{ item }">
                        <w-inline-text bold :text="item.name"/>
                    </template>
                </w-data-table>
            </template>
        </w-app>
        
        <router-view/>
    </div>
</template>

